import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const Exchange: React.FC<IconProps> = ({
  color = '#fff',
  size = 24,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M6.262 19.35h9.987c3.066 0 5.64-2.167 6.262-5.073.145-.673-.415-1.228-1.067-1.228-.617 0-1.09.482-1.253 1.036a4.108 4.108 0 01-3.942 2.964H6.262l2.343-2.344a1.14 1.14 0 00-1.612-1.612l-4.298 4.298a1.118 1.118 0 00-.255 1.247l.138-.059-.138.06c.06.138.146.263.255.367l4.298 4.299a1.14 1.14 0 101.612-1.612l-2.343-2.344zm2.488-12s0 0 0 0h9.987l-2.343 2.344a1.14 1.14 0 001.612 1.611l4.298-4.298a1.116 1.116 0 000-1.615l-4.3-4.298a1.14 1.14 0 10-1.611 1.612l2.344 2.343H8.75c-3.066 0-5.64 2.168-6.263 5.075-.144.672.415 1.226 1.066 1.226.617 0 1.091-.484 1.253-1.039A4.116 4.116 0 018.75 7.35z"
      fill={color}
      stroke={color}
      strokeWidth={0.3}
    />
  </svg>
)
